/**
 * @generated SignedSource<<4993babd8f00a2ac4349d3cc8f6ac9e2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type bigReadQuery$data = {
  readonly bigReadQueue: {
    readonly " $fragmentSpreads": FragmentRefs<"bigReadContentQueue">;
  } | null | undefined;
  readonly bigReadSection: {
    readonly " $fragmentSpreads": FragmentRefs<"headlineSection">;
  };
  readonly " $fragmentType": "bigReadQuery";
};
export type bigReadQuery$key = {
  readonly " $data"?: bigReadQuery$data;
  readonly " $fragmentSpreads": FragmentRefs<"bigReadQuery">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "bigReadQuery",
  "selections": [
    {
      "alias": "bigReadSection",
      "args": [
        {
          "kind": "Literal",
          "name": "filter",
          "value": {
            "entityId": "515471"
          }
        }
      ],
      "concreteType": "Section",
      "kind": "LinkedField",
      "name": "section",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "headlineSection"
        }
      ],
      "storageKey": "section(filter:{\"entityId\":\"515471\"})"
    },
    {
      "alias": "bigReadQueue",
      "args": [
        {
          "kind": "Literal",
          "name": "filter",
          "value": {
            "name": "section_top_515471"
          }
        }
      ],
      "concreteType": "Queue",
      "kind": "LinkedField",
      "name": "queue",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "bigReadContentQueue"
        }
      ],
      "storageKey": "queue(filter:{\"name\":\"section_top_515471\"})"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "3b00bcb85c0101b89919d7fda0b1dcfa";

export default node;
